// ============================================
// 👤 PERSONAL INFORMATION
// ============================================
// Update your basic information here
// This data appears in the Hero section and throughout the portfolio
//
// 📝 HOW TO UPDATE:
// 1. Change "name" to your full name
// 2. Update "title" with your current role/aspiration
// 3. Update "subtitle" with your specialization
// 4. Change "email" and "phone" to your contact details
// 5. Update "location" to your city/country
// 6. Replace profile image in public/assets/ folder
// 7. Update "summary" with your professional bio
// 8. Update "metrics" with your actual numbers
// 9. Update "resumeUrl" path if you rename your resume file
// ============================================

export const personalInfo = {
  // 📛 Your full name (appears in Hero section with crown icon 👑)
  name: "Smith C",
  
  // 💼 Your main title/role (appears in typewriter animation)
  title: "Aspiring Software Developer",
  
  // 🎯 Your specialization (appears in typewriter animation)
  subtitle: "Backend Development & Web Technologies Specialist",
  
  // 📧 Your email address (appears in Contact section and marquee)
  email: "mrmithcit@gmail.com",
  
  // 📱 Your phone number (appears in Contact section)
  phone: "+91-9361491329",
  
  // 📍 Your location (appears in Contact section)
  location: "Chennai, India",
  
  // 🖼️ Profile image path (place your image in public/assets/ folder)
  profileImage: "/assets/profile.jpg",
  
  // 📄 Your professional summary (appears in Hero and About sections)
  summary: "I am an aspiring software developer with hands-on experience in backend development and web technologies. Currently working as a Full-Stack Intern at Znyck Technologies, I specialize in Node.js, Express.js, React.js, and database technologies including MongoDB and PostgreSQL. With a strong foundation in computer science and practical experience in building scalable applications, I am passionate about creating efficient solutions and continuously learning new technologies.",
  
  // ✅ Your current availability status
  availability: "Open to opportunities",
  
  // 📊 Your key metrics (appears in Hero section stats)
  metrics: {
    experience: "1+ Year",      // Update with your years of experience
    projects: "6 Projects",      // Update with your project count
    technologies: "12+ Technologies"  // Update with your tech stack count
  },
  
  // 📎 Resume file path (place your PDF in public/assets/ folder)
  // Make sure the filename matches or update this path
  resumeUrl: "/assets/Smith_C_Resume.pdf"
};

export default personalInfo;